import ProductTransformer from './ProductTransformer';

export default class ProductChangeSelectionTransformer extends ProductTransformer {
  static addFootnote(fn, product) {
    if (fn.name === 'footNoteChangeSelection') {
      product.footnotes.push(fn.text);
    }
  }

  static parseFootnotes(product, footnotes) {
    [
      'productName',
      'priceInformation',
      'promotionPriceOverrideText',
      'regularPriceOverrideText',
      'minimumCommitmentPeriodOverrideText',
      'minimumCommitmentPeriodText',
      'productDescriptionChangeSelection',
      'headerTitleProductChangeSelection',
      'promotionPriceOverrideText',
      'regularPriceOverrideText',
    ].forEach(field => {
      product.texts[field] = footnotes.parse(product.texts[field]);
    });
  }
}
